import React from 'react'
import { BeWizrLinkItem } from '~/models'
import { memo } from '~/ui/component'
import { Panel } from '~/ui/components'
import { createUseStyles } from '~/ui/styling'
import { LinkView } from '../media'

export interface Props {
  item: BeWizrLinkItem
}

const BeWizrLinkItemView = memo('BeWizrLinkItemView', (props: Props) => {

  const {item} = props

  const title = item.openGraphJson?.title ?? item.title
  const description = item.openGraphJson?.description

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <Panel classNames={$.panel}>
        <LinkView
          url={item.externalUrl}
          image={item.openGraphJson?.image ?? undefined}
          title={title}
          description={description ?? undefined}
        />
      </Panel>
    )
  }

  return render()

})

export default BeWizrLinkItemView

const useStyles = createUseStyles({
  panel: {
    overflow: 'hidden',
  },
})